import './styles.css';

import React, { Component } from 'react';

export default class CardStub extends Component {
    renderEdge(edge = 'Left')
    {
    	const exactEdge = 'edgeContainer' + edge;
    	return (
    		<div className={'d-flex flex-column edgeContainer ' + exactEdge}>
        		<div className="edge edgeTop"></div>
        		<div className="edge rip">
                    <img className="shadowRip" src="./images/semi-circle.svg" width="16" height="32" alt=""/>
                </div>
        		<div className="edge edgeBottom"></div>
        	</div>
    	)
    }

    render()
    {
        return(
            <div className="flex-column cardStubContainer" {...this.props}>
                <div className="flex-row topBorder z-depth-1">
                </div>
        
                <div className="cardStub d-flex align-self-stretch flex-row align-items-stretch">

                	{this.renderEdge('Left')}

                	<div className="d-flex cardStubInner">
                    	{this.props.children}
                    </div>

                    {this.renderEdge('Right')}
                </div>

                <div className="flex-row bottomBorder z-depth-1">
                </div>
            </div>
        )
    }

}
